import request from '@/utils/request'


// 查询学段列表
export function listSchoolStage(query) {
  return request({
    url: '/biz/admin/school/stage/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学段分页
export function pageSchoolStage(query) {
  return request({
    url: '/biz/admin/school/stage/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询学段详细
export function getSchoolStage(data) {
  return request({
    url: '/biz/admin/school/stage/detail',
    method: 'get',
    params: data
  })
}

// 新增学段
export function addSchoolStage(data) {
  return request({
    url: '/biz/admin/school/stage/add',
    method: 'post',
    data: data
  })
}

// 修改学段
export function updateSchoolStage(data) {
  return request({
    url: '/biz/admin/school/stage/edit',
    method: 'post',
    data: data
  })
}

// 删除学段
export function delSchoolStage(data) {
  return request({
    url: '/biz/admin/school/stage/delete',
    method: 'post',
    data: data
  })
}
